import { AppProvider } from '@!/providers'
import Inquiry from '@!/Inquiry/containers/Inquiry'
import { useAppSettings } from '@!/Hooks/useAppSettings'

const InquiryApp = () => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Inquiry />
    </AppProvider>
  )
}

export default InquiryApp
